import { Badge, Button, Table } from "@mantine/core";
import dayjs from "dayjs";
import React from "react";

import { Project, User } from "types";

import styles from "./ManageMembersTable.module.css";
import { useQueryClient } from "@tanstack/react-query";
import { useUser } from "hooks/useUser";
import { Trash } from "tabler-icons-react";
import {
  MemberPayload,
  useRemoveProjectMembers,
} from "api/projects/useAddProjectMembers";

type ManageMembersTableProps = {
  project: Project;
  orgId: string | undefined;
  projects: Project[];
  onClose: () => void;
};

function ManageMembersTable({
  project,
  orgId,
  projects,
  onClose,
}: ManageMembersTableProps) {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const { mutate: removeMembers, isLoading } = useRemoveProjectMembers();

  const members =
    projects.filter((item) => item._id === project._id)[0]?.members ?? [];

  const handleSubmit = async (member: User<string>) => {
    const payload: MemberPayload = {
      projectId: project?._id,
      memberIds: [member._id],
    };

    removeMembers(payload);
    await queryClient.invalidateQueries(["org", user.org?._id, "projects"]);
    onClose();
  };
  return (
    <div className={styles.container}>
      <Table
        withBorder
        className={styles.table}
        verticalSpacing="md"
        horizontalSpacing={20}
      >
        <thead>
          <tr>
            <th className={styles.action}>&nbsp;</th>
            <th>NAME</th>
            <th>POSITION</th>
            <th>ROLE</th>
            <th>MEMBER SINCE</th>
          </tr>
        </thead>
        <tbody>
          {members.map((member) => (
            <tr key={member._id}>
              <td>
                {member._id !== user._id && (
                  <Button
                    color="red.8"
                    size="sm"
                    pl={6}
                    pr={6}
                    disabled={isLoading}
                    onClick={() => handleSubmit(member)}
                  >
                    <Trash size={18} />
                  </Button>
                )}
              </td>
              <td>{`${member.firstName} ${member.lastName}`}</td>
              <td>{member.position}</td>
              <td>
                <Badge color="violet.7" size="lg">
                  {member.role}
                </Badge>
              </td>
              <td>{dayjs(member.createdAt).format("DD MMM YYYY")}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
export default ManageMembersTable;
